import moment from 'moment'

/**
 * 時間ticksを丸めて表示するためのオプション
 * scales[scaleId]にマージして使用する
 * @param {Moment|number} from 開始時刻
 * @param {Moment|number} to 終了時刻
 * @param {number} [ticksTimeOffset=0] ticks の value を時間に変換するときのオフセット(ms)
 */
const getTimeTicksRoundOption = (from, to, ticksTimeOffset = 0) => {
  return {
    type: 'time',
    time: {
      unit: 'minute',
      source: 'data',
      displayFormats: {
        day: 'HH:mm',
        hour: 'HH:mm',
        minute: 'HH:mm',
      },
      tooltipFormat: 'YYYY/MM/DD HH:mm:ss.SSS',
      round: true,
      stepSize: 1, // まずは1分単位でticksの元を作る
    },
    ticks: {
      autoSkipPadding: 10,
      maxRotation: 0,
      major: {
        enabled: true,
      },
    },
    afterBuildTicks: (scale) => {
      /**
       * ticks 丸め手順
       * 1. 1分おきのseriesデータ作成(stepSize: 1 を渡して chart.js にやらせる)
       * 2. 最初のo'clockとなるindexを探す
       * 3. 時間数 x 10 分の間隔を設定(24時間のときは多すぎるので180分に頭打ち)
       * 4. 該当する tick 値に major フラグを立てて autoSkip で残るようにする
       */
      // 2.最初のo'clockとなるindexを探す
      const times = scale.ticks.map((t) => moment(t.value + ticksTimeOffset))
      const oClockIndex = times.findIndex((t) => t.minute() === 0)
      // 3. ticks間隔設定
      const increment = Math.min(moment.duration(to - from).hours() * 10, 180)
      // 4. 該当する tick 値に major フラグを立てる
      const startIndex = oClockIndex % increment
      for (let i = startIndex; i < times.length; i = i + increment) {
        scale.ticks[i].major = true
      }
    },
  }
}

export default getTimeTicksRoundOption
